
import { Component, Vue } from "vue-property-decorator";
import TopAppBar from "@/components/base/TopAppBar.vue";

@Component({
  components: {
    TopAppBar,
  },
  metaInfo: {
    title: 'Политика конфиденциальности',
  },
})
export default class PrivacyPolicy extends Vue {}
